import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import axios from 'axios';
import { Link } from "react-router-dom";
import { getCDNUrl } from "../commons/CommonFunctions";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";

class BelongHereSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            size: 10,
            belongHereDataList: [],
            responseMessage: ''
        }
    }

    componentDidMount(){
        this.getBelongHereDataList();
    };

    getBelongHereDataList = () => {
        axios({
            method: "GET",
            url: `${process.env.REACT_APP_userServiceURL}/backend/pre/login/belong/getPublicList?page=${this.state.page}&size=${this.state.size}&loginType=PRE_LOGIN`,
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        })
            .then((response) => {
                if (response && response.data && response.data.message === "Success!") {
                    this.setState({
                        belongHereDataList: response?.data?.body?.content,
                        responseMessage: response.data?.message
                    })
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    getBelongHereData = () => {
        return  this.state.responseMessage === 'Success!' ? 

        <div className='lndimpctrightcolInn'>

            <div className="innerdiv">
                {this.state.belongHereDataList && this.state.belongHereDataList.length > 0 && this.state.belongHereDataList.slice(0,4).map((item,index)=> {
                    return  <div className="lndBelongGrid">
                                <a href={item?.link} target="_blank" >
                                    <LazyLoadImage effect="blur"
                                        src={
                                            item?.attachment && item?.attachment?.attachmentUrl ? getCDNUrl(item?.attachment?.attachmentUrl) : "https://cdn.dscovr.com/images/howImp4-new.png"
                                        }
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = "https://cdn.dscovr.com/images/howImp4-new.png"
                                        }}
                                        alt="Organisations working for nature, aiding policy framework, improving awareness and in turn making a better place for all of us to live" />
                                    <div className="textdesc">
                                        <h5>{item?.title}</h5>
                                    </div>
                                </a>
                            </div>})}
            </div>

            <div className="innerdiv">
                {this.state.belongHereDataList && this.state.belongHereDataList.length > 4 && this.state.belongHereDataList.slice(4,8).map((item,index)=> {
                    return  (<div className="lndBelongGrid">
                                <a href={item?.link} target="_blank" >
                                    <LazyLoadImage effect="blur"
                                        src={
                                            item?.attachment && item?.attachment?.attachmentUrl ? getCDNUrl(item?.attachment?.attachmentUrl) : "https://cdn.dscovr.com/images/howImp4-new.png"
                                        }
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = "https://cdn.dscovr.com/images/howImp4-new.png"
                                        }}
                                        alt="" />
                                    <div className="textdesc">
                                        <h5>{item?.title}</h5>
                                    </div>
                            </a>
                            </div>)})}
            </div>
        </div>
        :
        <div className='lndimpctrightcolInn'>

            <div className="innerdiv">
                {Array(4).fill().map((item, index) => (
                        <div className="lndBelongGrid skeletonBlk" key={index}>
                            <SkeletonTheme >
                                <Skeleton width="100%" height={'100%'} />
                                <div className="textdesc">
                                    <Skeleton width="100%" height={36} />
                                </div>
                            </SkeletonTheme>
                        </div>
                    
                    ))}
            </div>

            <div className="innerdiv">
                {Array(4).fill().map((item, index) => (
                        <div className="lndBelongGrid skeletonBlk">
                            <SkeletonTheme >
                                    <Skeleton width="100%" height={'100%'} />
                                        <div className="textdesc">
                                            <Skeleton width="100%" height={36} />
                                        </div>
                            </SkeletonTheme>
                        </div>
                    ))}
            </div>

        </div>
    }

    render() {
        const{belongHereDataList} = this.state;
        return (
             <section className="lndhwimpact">
                <div className="container">
                    <div className="lndhwimpctbgbx">
                        <div className="row">
                            <div className="lndimpctleftcol">
                                <h3>They <span>BELONG</span> Here</h3>
                            </div>
                            <div className="lndimpctrightcol">
                                {this.getBelongHereData()}
                                
                                {/* <div className='lndimpctrightcolInn'>

                                    <div className="innerdiv">
                                        {belongHereDataList && belongHereDataList.length > 0 && belongHereDataList.slice(0,4).map((item,index)=> {
                                            return  <div className="lndBelongGrid">
                                                        <a href={item?.link} target="_blank" >
                                                            <LazyLoadImage effect="blur"
                                                                src={
                                                                    item?.attachment && item?.attachment?.attachmentUrl ? getCDNUrl(item?.attachment?.attachmentUrl) : "https://cdn.dscovr.com/images/howImp4-new.png"
                                                                }
                                                                onError={(e) => {
                                                                    e.target.onerror = null;
                                                                    e.target.src = "https://cdn.dscovr.com/images/howImp4-new.png"
                                                                }}
                                                                alt="Organisations working for nature, aiding policy framework, improving awareness and in turn making a better place for all of us to live" />
                                                            <div className="textdesc">
                                                                <h5>{item?.title}</h5>
                                                            </div>
                                                        </a>
                                                    </div>})}
                                    </div>

                                    <div className="innerdiv">
                                        {belongHereDataList && belongHereDataList.length > 4 && belongHereDataList.slice(4,8).map((item,index)=> {
                                            return  (<div className="lndBelongGrid">
                                                        <a href={item?.link} target="_blank" >
                                                            <LazyLoadImage effect="blur"
                                                                src={
                                                                    item?.attachment && item?.attachment?.attachmentUrl ? getCDNUrl(item?.attachment?.attachmentUrl) : "https://cdn.dscovr.com/images/howImp4-new.png"
                                                                }
                                                                onError={(e) => {
                                                                    e.target.onerror = null;
                                                                    e.target.src = "https://cdn.dscovr.com/images/howImp4-new.png"
                                                                }}
                                                                alt="" />
                                                            <div className="textdesc">
                                                                <h5>{item?.title}</h5>
                                                            </div>
                                                    </a>
                                                    </div>)})}
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

           
        );
    }
}

export default BelongHereSection;